import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import dataImg from "../images/data.webp"

const DATASETS = [
  {
    key: "daa",
    label: "Democrats and Autocrats: Pathways of Subnational Undemocratic Regime Continuity within Democratic Countries (2015)",
  },
  {
    key: "wwaic",
    label: "Who Wants an Independent Court? Political Competition and Supreme Court Autonomy in the Argentine Provinces (1984-2008) (2015)",
  },
]

function FilesLoad() {
  const result = useStaticQuery(graphql`
    query DataSectionQuery {
      daa: allFile(filter: { sourceInstanceName: { eq: "daa" } }) {
        edges { node { publicURL name } }
      }
      wwaic: allFile(filter: { sourceInstanceName: { eq: "wwaic" } }) {
        edges { node { publicURL name } }
      }
    }
  `)

  return (
    <div>
      {DATASETS.map(({ key, label }, i) => (
        <div key={key} style={{ ...datasetBlock, ...(i === DATASETS.length - 1 ? { marginBottom: 0 } : {}) }}>
          <p style={datasetLabel}>{label}</p>
          <div style={fileList}>
            {result[key].edges.map(({ node }) => (
              <a key={node.name} href={node.publicURL} download style={fileRow}>
                <span style={fileName}>{node.name}</span>
                <span style={dlBtn}>Download</span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default function Data() {
  return (
    <section style={wrap} id="data">
      <div style={inner} className="ag-inner">
        <h2 style={titleStyle}>Data</h2>
        <div style={layout} className="data-layout">

          {/* Left column — dataset file lists */}
          <div style={leftCol}>
            <FilesLoad />
          </div>

          {/* Right column — background image */}
          <div style={rightCol} className="data-right-col">
            <div style={imgOverlay} className="data-img-overlay" />
            <a
              href="https://github.com/agustinagiraudy/data"
              target="_blank"
              rel="noopener noreferrer"
              style={githubBtn}
              className="data-github-btn"
            >
              View all data on GitHub<span className="github-arrow"> →</span>
            </a>
          </div>

        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .data-layout { grid-template-columns: 1fr !important; }
          .data-right-col { height: 240px !important; }
        }
        @media (max-width: 600px) {
          .data-right-col {
            background-image: none !important;
            height: auto !important;
            padding: 0 !important;
            display: block !important;
            margin-top: 8px !important;
          }
          .data-img-overlay { display: none !important; }
          .data-github-btn {
            color: var(--cobalt) !important;
            border-color: var(--cobalt) !important;
            background: transparent !important;
            backdrop-filter: none !important;
            padding: 11px 14px !important;
            font-size: 10px !important;
            letter-spacing: 0.14em !important;
            white-space: nowrap !important;
            display: block !important;
            text-align: center !important;
          }
          .github-arrow { display: none !important; }
        }
      `}</style>
    </section>
  )
}

const wrap = {
  background: "var(--cobalt-light)",
  padding: "96px 0",
}

const inner = {
  maxWidth: "1320px",
  margin: "0 auto",
  padding: "0 40px",
}

const titleStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "32px",
  letterSpacing: "0.04em",
  color: "var(--cobalt)",
  marginBottom: "48px",
}

const layout = {
  display: "grid",
  gridTemplateColumns: "1fr 380px",
  gap: "64px",
  alignItems: "stretch",
}

const leftCol = {
  minWidth: 0,
}

const rightCol = {
  position: "relative",
  backgroundImage: `url(${dataImg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  padding: "32px",
}

const imgOverlay = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to top, rgba(28,54,116,0.75) 0%, rgba(28,54,116,0.15) 60%)",
}

const githubBtn = {
  position: "relative",
  zIndex: 1,
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "white",
  border: "1px solid rgba(255,255,255,0.7)",
  padding: "13px 28px",
  textDecoration: "none",
  display: "inline-block",
  backdropFilter: "blur(4px)",
  background: "rgba(28,54,116,0.3)",
}

const datasetBlock = {
  marginBottom: "48px",
}

const datasetLabel = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "11px",
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: "var(--cobalt-mid)",
  marginBottom: "16px",
}

const fileList = {
  display: "flex",
  flexDirection: "column",
  gap: 0,
}

const fileRow = {
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  gap: "20px",
  padding: "16px 0",
  borderBottom: "1px solid var(--cream-mid)",
  textDecoration: "none",
  color: "inherit",
  transition: "opacity 0.15s",
}

const fileName = {
  fontSize: "17px",
  lineHeight: 1.4,
  color: "var(--ink)",
}

const dlBtn = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "9px",
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--cobalt-mid)",
  border: "1px solid var(--cobalt-mid)",
  padding: "5px 12px",
  whiteSpace: "nowrap",
}
